module.exports = __webpack_public_path__ + "img/success-outline.b24dd935.svg";